// 吃瓜五一 站点内容数据（展示用拟真内容）
// 数据均为原创虚构创作，仅用于网站内容演示。

export type CateKey = 'entertainment' | 'society' | 'variety' | 'life';

export interface Category {
  key: CateKey;
  label: string;
  subtitle: string;
  icon: string;
}

export const categories: Category[] = [
  { key: 'entertainment', label: '娱乐瓜田', subtitle: '明星八卦 · 圈内新料', icon: 'ri-user-star-line' },
  { key: 'society', label: '社会热点', subtitle: '身边大事 · 实时热议', icon: 'ri-global-line' },
  { key: 'variety', label: '影视综艺', subtitle: '新剧新综 · 口碑真相', icon: 'ri-clapperboard-line' },
  { key: 'life', label: '生活趣谈', subtitle: '趣事奇闻 · 烟火人间', icon: 'ri-cup-line' },
];

export interface HotTopic {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  cate: CateKey;
  up: boolean;
}

export const hotTopics: HotTopic[] = [
  { rank: 1, title: '年度最期待的新人演员路透流出，造型引全网对比', tag: '热议', heat: '1286万', cate: 'entertainment', up: true },
  { rank: 2, title: '一部剧带火一座城，取景地周末客流量翻了两番', tag: '新热', heat: '987万', cate: 'variety', up: true },
  { rank: 3, title: '高校毕业典礼上的发言金句刷屏，网友直呼破防', tag: '感动', heat: '861万', cate: 'society', up: true },
  { rank: 4, title: '综艺里被低估的黑马选手，一开口就圈粉无数', tag: '热综', heat: '734万', cate: 'variety', up: true },
  { rank: 5, title: '老牌选秀重启引怀旧潮，当年的初舞台你还记得吗', tag: '怀旧', heat: '612万', cate: 'entertainment', up: false },
  { rank: 6, title: '深夜摊贩摆摊十年上热搜，烟火气里藏着小温暖', tag: '暖心', heat: '543万', cate: 'life', up: true },
  { rank: 7, title: '揭秘演唱会抢票新套路，三条避坑提醒请收好', tag: '科普', heat: '472万', cate: 'society', up: false },
  { rank: 8, title: '被低估的中式糕点翻红，排队半小时就为这一口', tag: '生活', heat: '388万', cate: 'life', up: true },
];

export interface FeatureArticle {
  title: string;
  lead: string;
  tag: string;
  cate: CateKey;
  author: string;
  date: string;
  readTime: string;
  image: string;
  parts: string[];
}

export const featureArticles: FeatureArticle[] = [
  {
    title: '从"小透明"到话题顶流：一场翻红背后藏着什么？',
    lead: '一夜之间，路人甲也能变成热搜常客。我们顺着时间线复盘一场"意外走红"是如何被推着走向全网的，也聊聊流量来得快、去得也快的真相。',
    tag: '深度观察',
    cate: 'entertainment',
    author: '五月派瓜官',
    date: '09-06',
    readTime: '8 分钟',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20rising%20star%20figure%20stepping%20onto%20a%20spotlight%20stage%20surrounded%20by%20floating%20hearts%20and%20chat%20bubbles%20and%20camera%20flashes%2C%20warm%20coral%20red%20and%20cream%20editorial%20palette%2C%20bold%20flat%20vector%20art%20with%20soft%20grain%20texture%2C%20clean%20open%20space%20with%20subtle%20warm%20beige%20background%2C%20modern%20magazine%20cover%20aesthetic%2C%20no%20text&width=1400&height=900&seq=feature-red-01&orientation=landscape',
    parts: [
      '互联网最擅长的事，就是把一件小事放大成一场现象。当一个陌生名字频繁出现在你眼前，你会在第七次刷到时忍不住点进去——而每一次点击，都在为这场"翻红"添砖加瓦。',
      '复盘这类走红你会发现，它往往不是孤军奋战的结果，而是"内容足够有记忆点 + 恰好踩中情绪"的偶然碰撞。有人因为一句口误被做成表情包，有人因为一段接地气的发言被反复引用，围观者需要的从来不是完美的剧本，而是能代入的真情实感。',
      '但流量从来是一把双刃剑。热度最高的那几天，也是本人最容易被过度解读的时候。比起永远待在聚光灯下，更多人开始学会在喧嚣里留一分清醒：把作品做好，让关注自然沉淀。',
    ],
  },
  {
    title: '社交平台刷屏的"梗"，为何总在深夜爆发？',
    lead: '凌晨两点，你刷到一条让你笑出声的段子。第二天醒来，它已经传遍全网。深夜的互联网，究竟藏着怎样的流量密码？',
    tag: '现象拆解',
    cate: 'society',
    author: '瓜田观察员',
    date: '09-05',
    readTime: '6 分钟',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20people%20relaxing%20at%20night%20on%20sofas%20with%20phones%20glowing%2C%20dark%20navy-free%20warm%20night%20tones%20of%20deep%20brown%20and%20amber%20lamp%20light%2C%20memes%20and%20speech%20bubbles%20floating%20above%20screens%2C%20cozy%20humorous%20modern%20vector%20style%2C%20soft%20warm%20background%2C%20magazine%20layout%20illustration%2C%20no%20text&width=1400&height=900&seq=feature-night-02&orientation=landscape',
    parts: [
      '如果你常刷社交平台，会发现一个有趣的规律：真正能引爆全网的梗，往往诞生在深夜。白天大家忙于工作，讨论声被分散；到了晚上，疲惫的人群终于有了完整的时间去"吃瓜"、去分享、去抱团找共鸣。',
      '深夜的传播还有一个特点——情绪阈值更低。白天你可能理性地略过一条消息，但午夜刷到时，一点点的笑点或感伤都会被放大，于是忍不住转发并配上一句"太真实了"。这种瞬间的冲动，正是内容出圈最需要的燃料。',
      '对创作者而言，读懂这个规律意味着机会：把最有共鸣、最轻巧的那部分内容留在晚间投放，往往比清晨的"广撒网"更有效。毕竟，互联网的喧嚣总是在夜色里被彻底点燃。',
    ],
  },
];

export interface NewsItem {
  id: number;
  cate: CateKey;
  title: string;
  summary: string;
  image: string;
  reads: string;
  comments: string;
  date: string;
  tag: string;
}

export const newsFeed: NewsItem[] = [
  {
    id: 1,
    cate: 'entertainment',
    title: '新剧开机阵容官宣，顶配班底这次能打几分？',
    summary: '从编剧到配乐几乎全员"高配置"，首波海报就拉满期待值，唯一的问题是：高期待有时也是一把双刃剑。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20film%20clapperboard%20and%20camera%20silhouette%20in%20a%20warm%20studio%20scene%20with%20coral%20and%20gold%20accents%2C%20soft%20beige%20backdrop%2C%20elegant%20modern%20magazine%20vector%20style%2C%20clean%20negative%20space%2C%20no%20text&width=800&height=560&seq=grid-drama-01&orientation=landscape',
    reads: '32.6万',
    comments: '4287',
    date: '09-06',
    tag: '新剧',
  },
  {
    id: 2,
    cate: 'society',
    title: '小城演唱会经济爆火，一场演出带火整条街',
    summary: '越来越多演出选择落地二三线城市，本地餐饮与住宿同步被带动，文旅融合的甜头正在被看见。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20lively%20night%20concert%20crowd%20silhouettes%20with%20warm%20amber%20and%20coral%20stage%20lights%20and%20floating%20notes%2C%20cozy%20cream%20background%2C%20modern%20magazine%20vector%20style%20with%20soft%20grain%2C%20no%20text&width=800&height=560&seq=grid-concert-02&orientation=landscape',
    reads: '25.1万',
    comments: '3102',
    date: '09-06',
    tag: '现象',
  },
  {
    id: 3,
    cate: 'variety',
    title: '这档旅行综艺凭什么口碑一路走高？',
    summary: '没有剧本般的冲突，只有真实的相处与不赶时间的美景，慢综艺终于回归到"慢"本身。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20friends%20hiking%20a%20scenic%20warm%20hillside%20path%20with%20sun%20and%20gentle%20clouds%2C%20coral%20amber%20and%20soft%20cream%20palette%2C%20cozy%20modern%20vector%20travel%20magazine%20style%2C%20generous%20negative%20space%2C%20no%20text&width=800&height=560&seq=grid-travel-03&orientation=landscape',
    reads: '19.8万',
    comments: '2654',
    date: '09-05',
    tag: '热综',
  },
  {
    id: 4,
    cate: 'life',
    title: '深夜食堂观察：凌晨的店里藏着多少故事',
    summary: '热汤面的热气里，有人聊创业的起伏，有人说起还没打完的卡。生活不易，但幸好有深夜的一盏灯。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20warm%20small%20noodle%20shop%20at%20night%20seen%20from%20outside%2C%20glowing%20warm%20amber%20window%20light%20steam%20rising%2C%20cozy%20cream%20and%20coral%20tones%2C%20modern%20vector%20food%20illustration%20magazine%20style%2C%20soft%20shadows%2C%20no%20text&width=800&height=560&seq=grid-noodle-04&orientation=landscape',
    reads: '16.4万',
    comments: '2301',
    date: '09-05',
    tag: '烟火',
  },
  {
    id: 5,
    cate: 'entertainment',
    title: '考古十年前的爱豆舞台，DNA狠狠动了',
    summary: '当"爷青回"成为弹幕高频词，那些被封存的全开麦现场，正在成为新一代年轻人的考古对象。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20retro%20music%20stage%20with%20vinyl%20records%20and%20spotlight%20glow%20in%20coral%20and%20warm%20gold%20palette%2C%20cream%20background%2C%20nostalgic%20modern%20vector%20magazine%20style%2C%20no%20text&width=800&height=560&seq=grid-stage-05&orientation=landscape',
    reads: '13.2万',
    comments: '1988',
    date: '09-04',
    tag: '怀旧',
  },
  {
    id: 6,
    cate: 'life',
    title: '周末去哪儿？本地人私藏的三条citywalk路线',
    summary: '避开人潮的小众街巷、藏在转角的老字号，本地向导手把手教你用一天重新认识你生活的城市。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20person%20walking%20through%20a%20warm%20cozy%20old%20town%20street%20with%20shopfronts%20and%20hanging%20lights%20in%20coral%20amber%20and%20cream%20tones%2C%20modern%20vector%20city%20guide%20magazine%20style%2C%20inviting%20negative%20space%2C%20no%20text&width=800&height=560&seq=grid-citywalk-06&orientation=landscape',
    reads: '11.7万',
    comments: '1760',
    date: '09-04',
    tag: '攻略',
  },
];

export interface Review {
  name: string;
  text: string;
  likes: string;
  time: string;
}

export const reviews: Review[] = [
  { name: '隔壁老王吃瓜中', text: '第一篇深度稿我看完了，分析在点子上的同时还不带节奏，难得。', likes: '2.3万', time: '2 小时前' },
  { name: '奶茶不加糖', text: '那个深夜食堂的选题太戳我了，看完想立刻下楼吃碗面。', likes: '1.8万', time: '4 小时前' },
  { name: '今天也在卷', text: '评论区果然人才辈出，我是来看瓜的，结果被科普了一整晚。', likes: '1.2万', time: '6 小时前' },
  { name: '摸鱼大师', text: '希望多来点这种有深度的内容，别整天只发毫无营养的标题党。', likes: '9860', time: '昨天' },
  { name: '路人甲本甲', text: '从热榜点进来的，版面挺清爽，内容更新速度也够快，关注了。', likes: '7540', time: '昨天' },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  { q: '吃瓜五一每天几点更新内容？', a: '我们分为早间与晚间两个内容批次：早间 9 点左右集中上线前一晚沉淀的热点回顾，晚间 20 点到 23 点持续补充当天最新的新料与深度稿。遇到突发的大热点，我们会第一时间临时加更，尽量做到"瓜热不隔夜"。' },
  { q: '内容来源可靠吗？会不会乱带节奏？', a: '我们坚持原创与信息核实并重：所有深度观察均基于公开可查的信息与多方信源交叉确认，娱乐与社会类内容只做呈现与理性讨论，不主观臆断、不制造对立，也坚决不参与任何形式的造谣与传播。' },
  { q: '我可以投稿或者提供爆料线索吗？', a: '当然可以。你可以在页面底部的联系方式中找到我们的反馈邮箱，把线索与可核实的链接一并发给我们。稿件一经采用，我们会署名标注来源，并在沟通后决定是否对外发布。' },
  { q: '如何订阅每天的热瓜早报？', a: '在页面页脚填写你的邮箱并点击"订阅"即可，我们会为你每天推送一份经过筛选的热点精选，内容简洁、不含打扰式广告，也随时可以一键退订。' },
  { q: '你们会接商业推广吗？会标注吗？', a: '在保证信息真实与读者体验的前提下，我们接受与合作方价值匹配的商业内容，但所有推广都会以显著方式标注"推广"字样，绝不会伪装成普通资讯来误导读者。' },
  { q: '站内文章可以转载吗？', a: '欢迎在注明出处与作者、并附上原文链接的前提下进行非商业转载。涉及商业转载或转载到大型媒体平台的，请先通过邮箱与我们取得授权，感谢尊重原创。' },
];